<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CookieConsent.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CookieConsent.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div class="cookie-consent--wrapper">
        <div v-on:click="showConsent"
             class="cookie-consent--trigger cursor-pointer">
            <div class="cookie-consent--trigger-container">
                <div class="cookie-consent--trigger-corner"><span>cookies</span></div>
            </div>
        </div>
        <div v-if="!consent || show"
             class="cookie-consent">
            <div class="cookie-consent--outer z-depth-4"
                 :class="{
            'show-info':show_info
            }">
                <div class="cookie-consent--inner">
                    <div class="cookie-consent--header">
                        <div class="d-flex justify-content-between align-content-center p-2 bg-info text-body">
                            <i class="material-icons">help</i>
                            <h2 class="h5 m-0 lh-7 fs-3">Cookie control</h2>
                        </div>

                        <div class="py-2 px-3 fs-3">
                            <p class="cookie-consent--title">
                                <span>We have placed cookies on your device to help make this website better.</span>
                            </p>
                            <div v-on:click="imFine"
                                 class="p-1 mx-0 btn btn-primary btn-sm cursor-pointer"
                                 :class="{
                                'w-100':!show_info
                            }"
                            >I'm fine with this
                            </div>
                            <div v-on:click="show_info=!show_info"
                                 class="p-1 mx-0 btn btn-info btn-sm cursor-pointer"
                            :class="{
                                'btn-info':!show_info,
                                'btn-primary':show_info,
                                'w-100':!show_info
                            }"
                            >More Info</div>
                        </div>

                    </div>
                    <div v-if="show_info"
                         class="cookie-consent--content px-3 fs-3">
                        <div class="cookie-consent--ci">
                            <div class="cookie-consent--intro">
                                <p>We have placed cookies on your device to help make this website better.</p>
                                <p>By continuing to use this site, we’ll assume you’re OK to continue.</p>

                                <p>To view more information you can also <a href="/cookies">read our cookies policy</a> </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "cookie-consent",
        props: {
            cookie: {
                type: Number,
                default: 0
            },
            url: {
                type: String,
                default: '/cookies'
            },
            cookie_consent_name:{
                type:String,
                default:'est_cookie_consent'
            },
        },
        data() {
            return {
                consent: false,
                show: true,
                show_info: false
            }
        },
        mounted(){
            let self = this;

            self.consent = self.getCookie();
            self.show = !self.consent;
        },
        methods: {
            showConsent() {
                let self = this;
                self.show = true;
                self.show_info = false;
            },
            getCookie() {
                let self = this;

                let name = self.cookie_consent_name + "=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for(let i = 0; i <ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            },
            imFine() {
                let self = this;
                self.consent = true;
                self.show
                    = self.show_info
                    = false;
                document.cookie = `${self.cookie_consent_name}=true`
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/cookies/CookieConsent.vue